const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://RohitSuthar.com',
  title: 'SR.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Suthar Rohit',
  role: 'Software Engineer',
  description:
    'ReactNative | Flutter | Android | Kotlin | PHP | Laravel | CodeIgniter | MySQL | MongoDB | Front-End | JavaScript | Team Lead | Project Manager | 12+ Years of Experience',
  // resume: 'https://example.com',
  social: {
    linkedin: 'https://www.linkedin.com/in/RohitSuthar',
    twitter: 'https://www.twitter.com/theRohitSuthar',
    facebook: 'https://www.facebook.com/RohitSuthar',
    instagram: 'https://www.instagram.com/RohitSuthar',
    github: 'https://github.com/theRohitSuthar',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  // {
  //   name: 'Project 1',
  //   description:
  //     'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
  //   stack: ['SASS', 'TypeScript', 'React'],
  //   sourceCode: 'https://github.com',
  //   livePreview: 'https://github.com',
  // },
  // {
  //   name: 'Project 2',
  //   description:
  //     'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
  //   stack: ['SASS', 'TypeScript', 'React'],
  //   sourceCode: 'https://github.com',
  //   livePreview: 'https://github.com',
  // },
  // {
  //   name: 'Project 3',
  //   description:
  //     'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
  //   stack: ['SASS', 'TypeScript', 'React'],
  //   sourceCode: 'https://github.com',
  //   livePreview: 'https://github.com',
  // },
]

const skills = [
  'ReactNative', 'Flutter', 'Android', 'Kotlin', 'NodeJS', 'ExpressJS', 'NestJS', 'Vue', 'PHP', 'Laravel', 'CodeIgniter', 'MySQL', 'MongoDB', 'Front-End', 'Back-End', 'JavaScript', 'Team Lead', 'Project Manager',  'CI/CD', 'Artificial Intelligence', 'MUI', 'React', 'Tailwind', 'Bootstrap', 'HTML', 'CSS', 'Git', 'GitHub', 'Bitbucket', 'Jira', 'Trello', 'Slack', 'Figma', 'Adobe XD', 'Photoshop', 'Github Actions', 'Firebase', 'Google Cloud Platform', 'AWS', 'Digital Ocean', 'Postman', 'Insomnia', 'GraphQL', 'WebSockets', 'Socket.IO', 'Redis', 'Docker', 'Kubernetes', 'S3',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'hi@RohitSuthar.com',
}

export { header, about, projects, skills, contact }
